import React from 'react';
import styled from 'styled-components';

const Line = styled.line`
  stroke: #eee;
  stroke-width: 1;
  shape-rendering: crispEdges;
`;

export default ({ width, yScale }) => (
  <g>
    {yScale.ticks(7).map(tick => (
      <g key={tick} transform={`translate(0, ${yScale(tick)})`}>
        <Line x1={0} x2={width} />
      </g>
    ))}
  </g>
);
